import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { NonAuthRoutes, Modules } from '../../../enums';
import { AuthContext } from '../../../contexts/AuthContext';
import { redirectBasedOnPermission } from '../../../utils/methods';
import Brand from './Brand';
import LoginIllustrations from './LoginIllustration';

interface PublicLayoutProps {
  route: NonAuthRoutes;
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ route, children }) => {
  const { token, permissions, isSystemAdmin } = useContext(AuthContext);

  if (token) {
    return (
      <Navigate
        replace
        to={{
          pathname:
            redirectBasedOnPermission(isSystemAdmin, permissions) ||
            Modules.error + NonAuthRoutes.forbidden,
        }}
      />
    );
  }

  const illustration = route === NonAuthRoutes.login ? <LoginIllustrations /> : null;

  return (
    <main className="obs-public-auth-root d-flex align-items-center justify-content-center py-5 min-vh-100" style={{ backgroundColor: 'var(--void)' }}>
      <div className="authentication-wrapper authentication-basic container-p-y w-100" style={{ maxWidth: '410px' }}>
        <div className="authentication-inner py-2">
          <div className="card obs-login-card">
            <div className="card-body p-4 p-sm-5">
              <div className="app-brand justify-content-start mb-3">
                <Brand />
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PublicLayout;
